// Permanent redirect — the «Categories and profiles» step moved to
// /analysis-setup/categories (#2491): the old path read as the «Criteria» step
// (/analysis-setup/call-criteria). Links already sent (onboarding mail,
// bookmarks, docs) keep working; the tab and the profile ride along.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { validateCategoriesSearch } from '@/features/analysis-setup/categories-search';

export const Route = createFileRoute('/analysis-setup/criteria')({
  validateSearch: validateCategoriesSearch,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/analysis-setup/categories',
      search: { profileId: search.profileId, tab: search.tab },
      replace: true,
    });
  },
});
